/* Birdy Trendy — etkileşim katmanı */
(function () {
  'use strict';

  var cfg = window.tyConfig || { strings: {} };
  var FAV_KEY = 'ty_favs';

  /* ---------- yardımcılar ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var toastTimer;
  function toast(msg) {
    var el = $('.ty-toast');
    if (!el || !msg) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }
  window.tyToast = toast;

  function readFavs() {
    try {
      var v = JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function writeFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
  }

  /* ---------- mobil menü çekmecesi ---------- */
  function initDrawer() {
    var drawer = $('[data-ty-drawer]');
    if (!drawer) return;
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var c = $('.ty-drawer__close', drawer);
      if (c) c.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    $$('[data-ty-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-ty-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- favoriler ---------- */
  function syncFavButtons() {
    var favs = readFavs();
    $$('[data-ty-fav]').forEach(function (btn) {
      var on = favs.indexOf(btn.getAttribute('data-ty-fav')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    $$('[data-ty-fav-count]').forEach(function (el) {
      el.textContent = favs.length ? favs.length : '';
      el.setAttribute('data-count', favs.length);
    });
  }
  window.tySyncFavs = syncFavButtons;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ty-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-ty-fav');
    var favs = readFavs();
    var i = favs.indexOf(handle);
    if (i > -1) {
      favs.splice(i, 1);
      toast(cfg.strings.favRemoved);
      var card = btn.closest('[data-ty-fav-item]');
      if (card) card.remove();
      if (!favs.length) renderFavPage();
    } else {
      favs.unshift(handle);
      toast(cfg.strings.favAdded);
    }
    writeFavs(favs);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
    syncFavButtons();
  });

  function renderFavPage() {
    var root = $('[data-ty-favs]');
    if (!root) return;
    var grid = $('[data-ty-favs-grid]', root);
    var empty = $('[data-ty-favs-empty]', root);
    var favs = readFavs();
    if (!favs.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var jobs = favs.map(function (handle) {
      return fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=ty-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    });
    Promise.all(jobs).then(function (htmls) {
      var alive = [];
      htmls.forEach(function (html, idx) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.ty-card');
        if (!card) return;
        var li = document.createElement('li');
        li.setAttribute('data-ty-fav-item', '');
        li.appendChild(card);
        grid.appendChild(li);
        alive.push(favs[idx]);
      });
      if (alive.length !== favs.length) writeFavs(alive);
      if (!alive.length) { grid.hidden = true; empty.hidden = false; }
      syncFavButtons();
    });
  }

  /* ---------- hızlı sepete ekle ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ty-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var cartDrawer = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      fd.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement && cartDrawer.setActiveElement(btn);
      if (typeof cartDrawer.open === 'function') { cartDrawer.classList.add('ty-adding'); cartDrawer.open(); }
    } else {
      fd.append('sections', 'cart-icon-bubble');
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast(res.description || res.message || cfg.strings.error);
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(res);
        } else {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.sections && res.sections['cart-icon-bubble']) {
            var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          toast(cfg.strings.added);
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ty-quick-add', cartData: res });
        }
      })
      .catch(function () { toast(cfg.strings.error); })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
        if (cartDrawer && cartDrawer.classList.contains('ty-adding')) {
          cartDrawer.classList.remove('ty-adding');
          if (!cartDrawer.querySelector('.cart-item')) cartDrawer.close();
        }
      });
  });

  /* ---------- yatay kaydırıcılar ---------- */
  function initSliders(ctx) {
    $$('[data-ty-slider]', ctx).forEach(function (wrap) {
      if (wrap.__ty) return;
      wrap.__ty = true;
      var track = $('.ty-slider__track', wrap);
      var prev = $('.ty-slider__btn--prev', wrap);
      var next = $('.ty-slider__btn--next', wrap);
      if (!track) return;
      function update() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9 }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9 }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- hero slider ---------- */
  function initHeroes(ctx) {
    $$('[data-ty-hero]', ctx).forEach(function (root) {
      if (root.__ty) return;
      root.__ty = true;
      var track = $('.ty-hero__track', root);
      var slides = $$('.ty-hero__slide', root);
      var dots = $$('.ty-hero__dot', root);
      if (!track || slides.length < 2) return;
      var idx = 0;
      var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10) * 1000;
      var timer;

      function go(n) {
        idx = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + -idx * 100 + '%)';
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          s.tabIndex = i === idx ? 0 : -1;
        });
      }
      function play() {
        if (!delay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, delay);
      }
      function stop() { clearInterval(timer); }

      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
      var p = $('.ty-hero__arrow--prev', root);
      var n = $('.ty-hero__arrow--next', root);
      if (p) p.addEventListener('click', function () { go(idx - 1); play(); });
      if (n) n.addEventListener('click', function () { go(idx + 1); play(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);

      var sx = 0, sy = 0, moving = false;
      track.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; moving = true; stop();
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!moving) return;
        moving = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? idx + 1 : idx - 1);
        play();
      });

      go(0);
      play();
    });
  }

  /* ---------- geri sayım ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdowns(ctx) {
    $$('[data-ty-countdown]', ctx).forEach(function (el) {
      if (el.__ty) return;
      el.__ty = true;
      var mode = el.getAttribute('data-mode');
      var endAttr = el.getAttribute('data-end');
      function target() {
        if (mode === 'daily' || !endAttr) {
          var d = new Date();
          d.setHours(23, 59, 59, 999);
          return d.getTime();
        }
        var t = new Date(endAttr.replace(' ', 'T')).getTime();
        return isNaN(t) ? Date.now() : t;
      }
      var end = target();
      var boxes = {
        d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el)
      };
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0 && (mode === 'daily' || !endAttr)) { end = target() + 1000; }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        if (boxes.d) {
          boxes.d.textContent = pad(d);
          boxes.d.hidden = d === 0;
          var sep = boxes.d.nextElementSibling;
          if (sep && sep.hasAttribute('data-sep')) sep.hidden = d === 0;
        }
        if (boxes.h) boxes.h.textContent = pad(boxes.d && d ? h : h + d * 24);
        if (boxes.m) boxes.m.textContent = pad(m);
        if (boxes.s) boxes.s.textContent = pad(s % 60);
        if (diff === 0 && endAttr && mode !== 'daily') {
          var hideTarget = el.closest('[data-ty-hide-on-end]');
          if (hideTarget) hideTarget.hidden = true;
          return;
        }
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- kupon kopyala ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ty-copy]');
    if (!b) return;
    var code = b.getAttribute('data-ty-copy');
    var done = function () {
      b.classList.add('is-copied');
      toast(cfg.strings.copied + ': ' + code);
      setTimeout(function () { b.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  /* ---------- tahmini teslimat ---------- */
  var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function addBizDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) n--;
    }
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + DAYS[d.getDay()]; }
  function initDelivery(ctx) {
    $$('[data-ty-delivery]', ctx).forEach(function (el) {
      if (el.__ty) return;
      el.__ty = true;
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '15', 10);
      var ship = parseInt(el.getAttribute('data-ship') || '1', 10);
      var trans = parseInt(el.getAttribute('data-transit') || '2', 10);
      var shipEl = $('[data-ty-ship-date]', el);
      var fromEl = $('[data-ty-eta-from]', el);
      var toEl = $('[data-ty-eta-to]', el);
      var cdEl = $('[data-ty-cutoff-left]', el);
      function render() {
        var now = new Date();
        var cut = new Date(now.getTime());
        cut.setHours(cutoff, 0, 0, 0);
        var beforeCut = now < cut && now.getDay() !== 0;
        var offset = beforeCut ? ship : ship + 1;
        var shipDate = offset === 0 ? now : addBizDays(now, offset);
        var etaFrom = addBizDays(shipDate, trans);
        var etaTo = addBizDays(shipDate, trans + 1);
        if (shipEl) {
          var isToday = shipDate.toDateString() === now.toDateString();
          var tmr = new Date(now.getTime()); tmr.setDate(tmr.getDate() + 1);
          shipEl.textContent = isToday ? 'bugün' : fmt(shipDate);
        }
        if (fromEl) fromEl.textContent = fmt(etaFrom);
        if (toEl) toEl.textContent = fmt(etaTo);
        if (cdEl) {
          var wrap = cdEl.closest('[data-ty-cutoff-wrap]');
          if (beforeCut) {
            var left = Math.floor((cut - now) / 60000);
            cdEl.textContent = (left >= 60 ? Math.floor(left / 60) + ' sa ' : '') + (left % 60) + ' dk';
            if (wrap) wrap.hidden = false;
          } else if (wrap) {
            wrap.hidden = true;
          }
        }
      }
      render();
      setInterval(render, 60000);
    });
  }

  /* ---------- mobil yapışkan sepete ekle ---------- */
  function initStickyAtc() {
    var bar = $('[data-ty-sticky-atc]');
    if (!bar) return;
    var section = bar.getAttribute('data-section');
    var form = document.getElementById('product-form-' + section);
    var submit = form ? form.querySelector('[type="submit"]') : null;
    var priceBox = document.getElementById('price-' + section);
    var btn = $('.ty-btn', bar);
    if (!submit || !btn) { bar.remove(); return; }

    btn.addEventListener('click', function () {
      var disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      var picker = document.querySelector('variant-selects, .product-form__input');
      if (disabled && picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submit.click();
    });

    function syncPrice() {
      var target = $('[data-ty-sticky-price]', bar);
      if (!target || !priceBox) return;
      var sale = priceBox.querySelector('.price--on-sale');
      var cur = sale
        ? priceBox.querySelector('.price__sale .price-item--sale')
        : priceBox.querySelector('.price__regular .price-item--regular');
      var cmp = sale ? priceBox.querySelector('.price__sale s.price-item--regular') : null;
      target.innerHTML =
        (cmp ? '<s>' + cmp.textContent.trim() + '</s>' : '') + '<b>' + (cur ? cur.textContent.trim() : '') + '</b>';
      var disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      btn.textContent = disabled ? (submit.textContent.trim() || 'Tükendi') : btn.getAttribute('data-label');
    }
    syncPrice();
    if (priceBox && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
      new MutationObserver(syncPrice).observe(submit, { attributes: true, childList: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var above = en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !en.isIntersecting && above);
        });
      }).observe(submit);
    }
  }


  /* ---------- Şimdi Al: sepete ekle ve ödemeye git ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ty-buy-now]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var form = b.closest('form');
    if (!form) return;
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    var fd = new FormData(form);
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || res.message || cfg.strings.error); b.disabled = false; b.removeAttribute('aria-busy'); return; }
        window.location.href = '/checkout';
      })
      .catch(function () { toast(cfg.strings.error); b.disabled = false; b.removeAttribute('aria-busy'); });
  });
  function syncBuyNow() {
    $$('[data-ty-buy-now]').forEach(function (b) {
      var form = b.closest('form');
      var sub = form && form.querySelector('[type="submit"]');
      if (!sub || b.getAttribute('aria-busy')) return;
      var off = sub.disabled || sub.getAttribute('aria-disabled') === 'true';
      if (b.disabled !== off) b.disabled = off;
    });
  }

  /* ---------- Dönen bilgi şeridi ---------- */
  function initSocial(ctx) {
    $$('[data-ty-social]', ctx).forEach(function (el) {
      if (el.__ty) return;
      el.__ty = true;
      var items = $$('.ty-social__item', el);
      if (items.length < 2) return;
      var i = 0, ms = parseInt(el.getAttribute('data-speed') || '2500', 10);
      el.classList.add('is-ready');
      items[0].classList.add('is-on');
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, ms);
    });
  }


  /* ---------- Yarın kargoda saati (HH:MM:SS) ---------- */
  function initCutoffClock(ctx) {
    $$('[data-ty-cutoff-clock]', ctx).forEach(function (el) {
      if (el.__ty) return;
      el.__ty = true;
      var box = el.closest('[data-ty-delivery]');
      var cutoff = parseInt((box && box.getAttribute('data-cutoff')) || '24', 10);
      function tick() {
        var now = new Date();
        var t = new Date(now.getTime());
        t.setHours(cutoff, 0, 0, 0);
        if (t <= now) t.setDate(t.getDate() + 1);
        var s = Math.max(0, Math.floor((t - now) / 1000));
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Numara rehberi penceresi ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ty-guide-open]');
    if (o) {
      var d = o.parentElement.querySelector('[data-ty-guide]');
      if (d && d.showModal) d.showModal();
      return;
    }
    var c = e.target.closest('[data-ty-guide-close]');
    if (c) { c.closest('dialog').close(); return; }
    if (e.target.matches && e.target.matches('dialog[data-ty-guide]')) e.target.close();
  });

  /* ---------- başlat ---------- */
  function initAll(ctx) {
    initSliders(ctx);
    initHeroes(ctx);
    initCountdowns(ctx);
    initDelivery(ctx);
    initSocial(ctx);
    initCutoffClock(ctx);
    syncFavButtons();
    syncBuyNow();
  }


  /* ---------- Renk seçimine göre galeri (yalnızca seçili rengin görselleri) ---------- */
  var COLOR_OPTS = ['renk', 'model', 'color', 'colour'];
  function selectedColor(root) {
    var sets = root.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');
    for (var i = 0; i < sets.length; i++) {
      var lab = sets[i].querySelector('legend, label.form__label');
      if (!lab) continue;
      var name = lab.childNodes[0] ? String(lab.childNodes[0].textContent || '').replace(':', '').trim().toLocaleLowerCase('tr') : '';
      if (COLOR_OPTS.indexOf(name) === -1) continue;
      var c = sets[i].querySelector('input:checked');
      if (c) return c.value;
      var sel = sets[i].querySelector('select');
      if (sel) return sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].value : '';
    }
    return '';
  }
  function filterGallery(root) {
    var gal = root.querySelector('media-gallery');
    if (!gal) return;
    var val = selectedColor(root);
    var items = gal.querySelectorAll('[id^="Slider-Gallery"] > li, [id^="Slider-Thumbnails"] > li');
    var key = ' - ' + val + ' - ';
    var match = function (li) { var im = li.querySelector('img'); return !!(im && im.alt && im.alt.indexOf(key) > -1); };
    var any = false;
    if (val) items.forEach(function (li) { if (match(li)) any = true; });
    items.forEach(function (li) { li.classList.toggle('ty-media-off', any && !match(li)); });
    gal.querySelectorAll('slider-component').forEach(function (sc) { if (sc.resetPages) try { sc.resetPages(); } catch (e) {} });
    // aktif görsel gizlendiyse ilk görünen görsele geç
    var main = gal.querySelector('[id^="Slider-Gallery"]');
    var active = main && main.querySelector('li.is-active');
    if (any && main && (!active || active.classList.contains('ty-media-off'))) {
      var first = main.querySelector('li:not(.ty-media-off)');
      if (first && gal.setActiveMedia) try { gal.setActiveMedia(first.dataset.mediaId, false); } catch (e) {}
    }
  }

  /* ---------- Açıklamadaki "Ürün Kodu" varyanta göre ---------- */
  function initSkuRow() {
    function set(sku) { if (sku) document.querySelectorAll('[data-ty-sku]').forEach(function (e) { e.textContent = sku; }); }
    var j = document.querySelector('[data-selected-variant]');
    if (j) try { set(JSON.parse(j.textContent).sku); } catch (e) {}
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) { set(ev && ev.data && ev.data.variant && ev.data.variant.sku); });
    }
  }
  function initVariantGallery() {
    var roots = document.querySelectorAll('product-info');
    roots.forEach(function (r) { filterGallery(r); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        setTimeout(function () {
          document.querySelectorAll('product-info').forEach(function (r) { filterGallery(r); });
        }, 30);
      });
    }
  }


  /* ---------- Kart görsel şeridi noktaları (mobil kaydırma) ---------- */
  function initCardTracks() {
    var raf = null;
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-ty-track]')) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var dots = t.parentNode.querySelectorAll('.ty-card__dots i');
        if (!dots.length) return;
        var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }, true);
  }

  function boot() {
    initDrawer();
    initAll(document);
    renderFavPage();
    initStickyAtc();
    initVariantGallery();
    initSkuRow();
    initCardTracks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Tema düzenleyici desteği
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); renderFavPage(); });

  // Dawn filtre/sayfalama sonrası yeni kartlar
  if ('MutationObserver' in window) {
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { syncFavButtons(); syncBuyNow(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }
})();

/* ---------- Elya: akıcı sepet — Shopify cevabını beklemeden ekranı güncelle ---------- */
(function () {
  function fmt(c) { return Math.round(c / 100).toLocaleString('tr-TR') + ' TL'; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }

  function recalc(el) {
    var drawer = el.closest('cart-drawer');
    var root = drawer || el.closest('cart-items') || document;
    var rows = root.querySelectorAll('.cart-item[data-ty-unit]');
    if (!rows.length) return;
    var sum = 0;
    rows.forEach(function (r) {
      if (r.classList.contains('ty-removing')) return;
      var q = r.querySelector('input.quantity__input');
      var line = (parseInt(r.dataset.tyUnit, 10) || 0) * (q ? parseInt(q.value, 10) || 0 : 1);
      sum += line;
      var p = r.querySelector('.cart-item__price-wrapper span.price--end');
      if (p) p.textContent = fmt(line);
      var cl = r.querySelector('.eb-cmp-line');
      if (cl) cl.textContent = fmt((parseInt(cl.dataset.cmp, 10) || 0) * (q ? parseInt(q.value, 10) || 0 : 1));
    });
    var tot = drawer ? drawer.querySelector('.totals__total-value') : document.querySelector('#main-cart-footer .totals__total-value');
    if (tot) tot.textContent = fmt(sum);
  }

  // adet +/− : satır ve toplam anında
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('.cart-item[data-ty-unit] input.quantity__input')) recalc(t);
  }, true);

  // sil: satır anında kaybolur
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-remove-button');
    if (!b) return;
    var row = b.closest('.cart-item');
    if (!row || row.classList.contains('ty-removing')) return;
    row.classList.add('ty-removing');
    recalc(row);
    setTimeout(function () { row.style.display = 'none'; }, 180);
  }, true);

  // çekmece sunucudaki sepetle uyuşmuyorsa yeniden çiz (boş şablon + dolu sepet karışmasın)
  window.tyDrawerSync = function (drawer, closeIfEmpty) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var rows = drawer.querySelectorAll('.cart-item').length;
      var emptyTpl = !!drawer.querySelector('.drawer__inner-empty');
      var ok = !drawer.querySelector('.ty-optimistic') && (cart.item_count === 0 ? emptyTpl : (!emptyTpl && rows > 0));
      if (!ok) {
        return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
          drawer.renderContents({ sections: sections });
          if (closeIfEmpty && cart.item_count === 0) setTimeout(function () { drawer.close(); }, 30);
        });
      }
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      if (closeIfEmpty && cart.item_count === 0) drawer.close();
    }).catch(function () {});
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) {
      var d = document.querySelector('cart-drawer');
      if (d && window.tyDrawerSync) setTimeout(function () { window.tyDrawerSync(d); }, 0);
    }
  }, true);

  // sepete ekle: ürün çekmecede anında görünür
  window.tyAddPreview = function (form, drawer) {
    try {
      var inner = drawer.querySelector('.drawer__inner');
      if (!inner) return;
      var old = inner.querySelector('.ty-add-preview');
      if (old) old.remove();
      var info = form.closest('product-info') || document;
      var fd = form.form ? new FormData(form.form) : null;
      var vid = fd ? String(fd.get('id') || '') : '';
      var qi = form.form && form.form.id ? document.querySelector('input[name="quantity"][form="' + form.form.id + '"]') : null;
      var qty = qi ? parseInt(qi.value, 10) || 1 : 1;
      var price = [].slice.call(info.querySelectorAll('.price .price-item')).find(function (p) { return p.offsetParent && !p.closest('s'); });
      var unit = price ? parseInt(price.textContent.replace(/[^0-9]/g, ''), 10) * 100 : 0;
      // sepette aynı ürün varsa: adedi anında artır, sonuç gibi göster
      var same = vid && drawer.querySelector('.cart-item input.quantity__input[data-quantity-variant-id="' + vid + '"]');
      if (same) {
        same.value = (parseInt(same.value, 10) || 0) + qty;
        recalc(same);
        drawer.classList.add('ty-adding-soft');
        var row = same.closest('.cart-item');
        if (row) { row.classList.remove('ty-flash'); void row.offsetWidth; row.classList.add('ty-flash'); }
      } else if (drawer.querySelector('.cart-item')) {
        // dolu sepet: ürünü listeye gerçek satır gibi hemen ekle (sunucu cevabı gelince aynısıyla değişir)
        var title2 = ((info.querySelector('.product__title h1') || {}).textContent || '').trim();
        var img2 = info.querySelector('.product__media img') || info.querySelector('.product-media-container img');
        var tpl = drawer.querySelector('.cart-item');
        var nr = tpl.cloneNode(true);
        nr.removeAttribute('id');
        nr.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
        nr.classList.add('ty-optimistic', 'ty-flash');
        nr.dataset.tyUnit = String(unit);
        var im = nr.querySelector('.cart-item__image');
        if (im && img2) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = img2.currentSrc || img2.src; im.alt = ''; }
        var nm = nr.querySelector('.cart-item__name');
        if (nm) nm.textContent = title2;
        var det = nr.querySelector('.cart-item__details');
        if (det) {
          det.querySelectorAll('dl, p.product-option, ul.discounts').forEach(function (x) { x.remove(); });
          var cmpEl = [].slice.call(info.querySelectorAll('.price s.price-item')).find(function (p) { return p.offsetParent; });
          var cmpU = cmpEl ? parseInt(cmpEl.textContent.replace(/[^0-9]/g, ''), 10) * 100 : 0;
          var up = det.querySelector('.product-option');
          if (up) {
            up.className = 'product-option' + (cmpU > unit ? ' eb-cart-price' : '');
            up.innerHTML = '';
            if (cmpU > unit) { var s1 = document.createElement('s'); s1.textContent = fmt(cmpU); up.appendChild(s1); up.appendChild(document.createTextNode(' ')); }
            var s2 = document.createElement(cmpU > unit ? 'strong' : 'span'); s2.textContent = price ? fmt(unit) : ''; up.appendChild(s2);
          }
          var tw = nr.querySelector('.cart-item__price-wrapper');
          var ocl = nr.querySelector('.eb-cmp-line'); if (ocl) ocl.remove();
          var tpe = tw && tw.querySelector('span.price--end');
          if (tpe && cmpU > unit) { var ncl = document.createElement('s'); ncl.className = 'eb-cmp-line'; ncl.dataset.cmp = String(cmpU); tpe.parentNode.insertBefore(ncl, tpe); }
          var vals = [].slice.call(info.querySelectorAll('variant-selects input:checked, variant-selects select')).map(function (i) { return i.value; });
          if (vals.length) { var o = document.createElement('div'); o.className = 'product-option'; o.textContent = vals.join(' / '); det.appendChild(o); }
          var ok = document.createElement('div'); ok.className = 'ty-opt-ok'; ok.textContent = '✓ Sepete eklendi'; det.appendChild(ok);
        }
        var qin = nr.querySelector('input.quantity__input');
        if (qin) { qin.value = qty; qin.removeAttribute('data-quantity-line-key'); qin.dataset.quantityVariantId = vid; }
        var pe = nr.querySelector('.cart-item__price-wrapper span.price--end');
        if (pe) pe.textContent = fmt(unit * qty);
        tpl.parentNode.insertBefore(nr, tpl);
        var sc = drawer.querySelector('.drawer__cart-items-wrapper, cart-drawer-items');
        if (sc && sc.scrollTo) sc.scrollTo({ top: 0, behavior: 'smooth' });
        recalc(nr);
        drawer.classList.add('ty-adding-soft');
      } else {
        var title = (info.querySelector('.product__title h1') || {}).textContent || '';
        var img = info.querySelector('.product__media img') || info.querySelector('.product-media-container img');
        var opts = [].slice.call(info.querySelectorAll('variant-selects input:checked, variant-selects select')).map(function (i) { return i.value; }).join(' / ');
        var el = document.createElement('div');
        el.className = 'ty-add-preview';
        el.innerHTML =
          '<div class="ty-add-preview__ok"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Sepete eklendi</div>' +
          '<div class="ty-add-preview__row">' +
          (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '') +
          '<div><strong>' + esc(title.trim()) + '</strong>' + (opts ? '<span>' + esc(opts) + '</span>' : '') +
          '<span>' + qty + ' adet' + (price ? ' · ' + esc(price.textContent.trim()) : '') + '</span></div></div>';
        inner.prepend(el);
        // dolu sepette toplamı da anında güncelle
        var tot = drawer.querySelector('.totals__total-value');
        if (tot && unit && drawer.querySelector('.cart-item')) {
          var cur = parseInt(tot.textContent.replace(/[^0-9]/g, ''), 10) * 100 || 0;
          tot.textContent = fmt(cur + unit * qty);
          drawer.classList.add('ty-adding-soft');
        }
      }
      // sepet sayacı anında
      document.querySelectorAll('#cart-icon-bubble .ty-action__count').forEach(function (c) {
        var n = parseInt(c.textContent, 10); if (!isNaN(n)) c.textContent = n + qty;
      });
      // ağ takılırsa beyaz bekleme kalmasın: 10 sn sonra sepeti kendimiz çek
      setTimeout(function () {
        if (!drawer.classList.contains('ty-adding')) return;
        drawer.classList.remove('ty-adding', 'ty-adding-soft');
        var pv = drawer.querySelector('.ty-add-preview');
        if (pv) pv.remove();
        drawer.querySelectorAll('.ty-optimistic').forEach(function (x) { x.remove(); });
        window.tyDrawerSync(drawer, true);
      }, 10000);
    } catch (err) {}
  };
})();
